export default function Rust_Scope() {
  return (
    <div>
      <h1>Rust_Scope Component</h1>
      <p>This is the Rust_Scope page.</p>
    </div>
  );
}
